import {Component, Inject, Input, OnInit, Optional, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_ASYNC_VALIDATORS, NG_VALIDATORS, NG_VALUE_ACCESSOR, NgModel} from '@angular/forms';
import {animations} from '../../class';
import {NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {DateAdapter} from '@angular/material';
import {TranslateService} from '@ngx-translate/core';
import {moment} from 'ngx-bootstrap/chronos/test/chain';
import {PickerType} from 'ng-pick-datetime/date-time/date-time.class';

@Component({
  selector: 'app-datetime',
  template: `
    <div class="input-group datetime-input-group">
      <input class="form-control datetime-input"
             [owlDateTime]="dtDate" [owlDateTimeTrigger]="dtDate"
             [disabled]="disabled"
             [(ngModel)]="value"
             (change)="dateChanged($event.target['value'])"
             [max]="maxDate"
             [min]="minDate"
             [placeholder]="placeholder"
      />
      <span class="input-group-addon datetime-group-addon" [owlDateTimeTrigger]="dtDate" [disabled]="disabled">
        <i class="fa fa-calendar"></i>
      </span>
      <owl-date-time #dtDate [showSecondsTimer]="showSecondsTimer"
                     [pickerType]="pickerType"
                     [disabled]="disabled"></owl-date-time>
    </div>
  `,
  styles: [`
    .datetime-group-addon {
      font-size: 22px;
      line-height: 33px;
      margin-left: 3px;
    }
    .datetime-input {
      padding-left: 10px;
      border-radius: 3px;
    }
    .datetime-input-group {
      width: 180px;
      margin-bottom: 0;
    }
  `],
  animations,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: DateTimeComponent,
    multi: true,
  }],
})

export class DateTimeComponent implements OnInit, ControlValueAccessor {
  @Input() public placeholder: string;
  @Input() public disabled: boolean;
  @Input() public maxDate: any;
  @Input() public minDate: any;
  @Input() public showSecondsTimer: boolean;
  @Input() public pickerType: PickerType = 'calendar';

  @ViewChild(NgModel) model: NgModel;

  private innerValue: Date;

  private changed = new Array<(value: number) => void>();
  private touched = new Array<() => void>();

  constructor(
    @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
    @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
    private ngbDateParserFormatter: NgbDateParserFormatter,
    private _adapter: DateAdapter<any>,
    private _translateService: TranslateService
  ) {
    // super(validators, asyncValidators);
  }

  ngOnInit() {
    this._adapter.setLocale(this._translateService.currentLang);
  }

  onSelectDate(date: Date) {
  }


  get value(): Date {
    return this.innerValue;
  }

  set value(value: Date) {
    if (this.innerValue !== value) {
      this.innerValue = value;
      if (value) {
        this.changed.forEach(f => f(value.getTime()));
      } else {
        this.changed.forEach(f => f(null));
      }
    }
  }

  writeValue(value: Date) {
    if (value) {
      this.innerValue = new Date(value);
    }

  }

  registerOnChange(fn: (value: any) => void) {
    this.changed.push(fn);
  }

  registerOnTouched(fn: () => void) {
    this.touched.push(fn);
  }

  touch() {
    this.touched.forEach(f => f());
  }

  dateChanged(date: string) {
    const momentDate = moment(date, 'DD.MM.YYYY, HH:mm:ss');

    if (momentDate.isValid())
      this.value = momentDate.toDate();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/forms/components/datetime/date-time.component.ts